module.exports = __webpack_public_path__ + "img/regboobx1024-smallsmall.19cf8bb8.png";